import React, { useState } from "react";
import { SimpleCard } from "../../@gull";
import { Button, Card, Row, Col } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import LoaderButton from "../Common/LoaderButton";

const UploadForm = ({
  style,
  title,
  file,
  setFile,
  onUploadFile,
  verify,
  setHash,
  hash,
  uploading,
  setUploading,
  kabutoExplorerUrl,
}) => {
  const random = uuidv4();
  const [dragClass, setDragClass] = useState("");
  const isEmpty = file && file.length === 0;

  const handleFileSelect = (event) => {
    setFile(event.target.files[0]);
    setUploading(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragClass("drag-shadow");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.persist();
    setDragClass("");
    setFile(event.dataTransfer.files[0]);
    setUploading(false);
    return false;
  };

  const handleDragStart = (event) => {
    setDragClass("drag-shadow");
  };

  const uploadSingleFile = () => {
    onUploadFile(file);
  };

  const handleRemove = () => setFile([]);
  return (
    <div className="d-flex flex-1 justify-content-center">
      <SimpleCard className="col-9" title={title} style={style}>
        <div className="d-flex flex-wrap mb-4">
          {verify && (
            <div className="pb-3 input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">Hash</span>
              </div>
              <input
                type="text"
                value={hash}
                onChange={(e) => setHash(e.target.value)}
                className="form-control"
                placeholder="Please, enter your document hash here"
                aria-label="documentHash"
                disabled={!isEmpty}
              />
            </div>
          )}
          {!verify || (verify && hash === "") ? (
            <>
              <label htmlFor={`upload-single-file${random}`}>
                <Button className="btn-rounded" as="span">
                  <div className="flex flex-middle">
                    <i className="i-Share-on-Cloud"> </i>
                    <span>Choose File</span>
                  </div>
                </Button>
              </label>
              <input
                className="d-none"
                onChange={handleFileSelect}
                id={`upload-single-file${random}`}
                type="file"
              />
            </>
          ) : null}
        </div>
        {!verify || (verify && hash === "") ? (
          <>
            <div
              className={`${dragClass} dropzone mb-4 d-flex justify-content-center align-items-center`}
              onDragEnter={handleDragStart}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              {isEmpty ? (
                <span>Drop your file here</span>
              ) : (
                <h5 className="m-0">1 File selected</h5>
              )}
            </div>

            <Card className="mb-4">
              <Row className="align-items-center p-3">
                <Col lg={4} md={4}>
                  Name
                </Col>
                <Col lg={4} md={2} style={{ whiteSpace: "nowrap" }}>
                  Size
                </Col>
                {!verify && (
                  <Col lg={4} md={6} style={{ whiteSpace: "nowrap" }}>
                    Kabuto link
                  </Col>
                )}
              </Row>
              <hr className="mt-0 mb-3" />

              {isEmpty ? (
                <p className="p-3 py-0">No file selected</p>
              ) : (
                <Row className="align-items-center px-3" key={file.name}>
                  <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                    {file.name}
                  </Col>
                  <Col lg={2} md={2} sm={12} xs={12} className="mb-3">
                    {(file.size / 1024 / 1024).toFixed(1)} MB
                  </Col>
                  {!verify && kabutoExplorerUrl !== "" ? (
                    <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                      <a href={kabutoExplorerUrl}>{kabutoExplorerUrl}</a>
                    </Col>
                  ) : null}
                </Row>
              )}
            </Card>
          </>
        ) : null}
        <div>
          <div className="d-flex">
            <LoaderButton
              className="mr-2"
              disabled={verify ? hash === "" && isEmpty : isEmpty}
              onClick={uploadSingleFile}
              loading={uploading}
              animation="border"
              spinnerSize="sm"
            >
              Send
            </LoaderButton>
            {!isEmpty && (
              <Button variant="danger" onClick={handleRemove}>
                Remove
              </Button>
            )}
          </div>
        </div>
      </SimpleCard>
    </div>
  );
};

export default UploadForm;
